export default __webpack_public_path__ + "static/all-56a3091bb12cf5b6fb81b465075b4ea9.png";